import { departmentService } from "../../../../Api/Services/DepartmentService";
import { ACTION_NAMES, SLICE_NAMES } from "../../../../constants/action";
import { ERROR_MESSAGES } from "../../../../constants/error";
import createGenericSlice from "../../../../utils/reduxUtils/createEntitySlice";
import createServiceAsyncThunk from "../../../../utils/reduxUtils/createServiceAsyncThunk";
import { IDepartmentTaskListServiceResponse, IFetchDepartmentCategoryListPaylaod } from "../../types";

export const fetchDepartmentSubCategoryList = createServiceAsyncThunk<
  IDepartmentTaskListServiceResponse,
  IFetchDepartmentCategoryListPaylaod
>(
  ACTION_NAMES.FETCH_DEPARTMENT_WISE_SUB_CATEGORY_TASKS_LIST,
  ({
    page,
    size,
    departmentId,
    nodeLevel,
    parent_id,
  }: IFetchDepartmentCategoryListPaylaod) =>
    departmentService.getDepartmentsWiseCategoryList({
      page,
      size,
      department_id: departmentId,
      node_level: nodeLevel || undefined,
      parent_id: parent_id,
    }),
  ERROR_MESSAGES.DEPARTMENT_WISE_SUBCATEGORY_TASKS_LIST_FETCH_FAILURE
);

const departmentSubCategoryListSlice = createGenericSlice<
  IDepartmentTaskListServiceResponse,
  IFetchDepartmentCategoryListPaylaod
>(SLICE_NAMES.DEPARTMENT_SUB_CATEGORY_LIST, fetchDepartmentSubCategoryList);

export const {
  clearError: clearDepartmentSubCategoryListError,
  clearSuccessMessage: clearDepartmentSubCategoryListSuccess,
} = departmentSubCategoryListSlice.actions;

export default departmentSubCategoryListSlice.reducer;
